import { render, staticRenderFns } from "./tenderOfferPriceReturn.vue?vue&type=template&id=39734c6c&scoped=true&"
import script from "./tenderOfferPriceReturn.vue?vue&type=script&lang=js&"
export * from "./tenderOfferPriceReturn.vue?vue&type=script&lang=js&"
import style0 from "./tenderOfferPriceReturn.vue?vue&type=style&index=0&id=39734c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39734c6c",
  null
  
)

export default component.exports